import collectConsentedCookies from './collectConsentedCookies'


export default function getWhitelist(categories, cookies) {
  if ( !cookies ) {
    return []
  }

  const consentedCookies = collectConsentedCookies({
    categories,
    cookies,
  })

  if ( !consentedCookies ) {
    return []
  }

  return consentedCookies.map(({ name, domain, tracker_type }) => ({
    name,
    provider: domain,
    type: tracker_type,
  }))
}
